import type { IContent } from '../../../customTypings/epiBaseModels';
import type { EpiAdMetaInfoPageType } from '../../episerver/components/pages/EpiAdMetaInfoPage/EpiAdMetaInfoPageType';

import { getAuthTokenOrDefault } from '../../common/api/auth/getAuthToken';
import { directSectionsApi } from '../../common/api/sections/directSectionsApi';
import persistance from '../../common/persistance/persistance';
import { isInB2BCrossContext } from '../../common/utils/b2bUtils';
import { contentDeliveryApi } from '../../episerver/api/contentDeliveryApi';

const checkContentType = (content: IContent, contentType: string): boolean => {
    return content.contentType.includes(contentType);
};

const sectionFlow = {
    getAds: async (adContainerPageContentReferenceId: string): Promise<EpiAdMetaInfoPageType[]> => {
        const adPages = await contentDeliveryApi.getChildren<EpiAdMetaInfoPageType>({
            contentReferenceId: adContainerPageContentReferenceId,
        });

        const filtered = adPages.filter((page) => checkContentType(page, 'AdMetaInfoPageType'));
        return filtered;
    },
    getSectionTree: async (
        productionUnit: string,
        isB2bRoute: boolean,
        isCompanyUser: boolean,
        shoppingUserId?: string,
    ) => {
        const { token } = await getAuthTokenOrDefault();
        // user
        const tree = persistance.ecommerceSections.get({
            productionUnit,
            isB2bRoute,
            isCompanyUser,
            shoppingUserId,
        });
        if (tree) {
            return tree;
        }

        let userId: string | 'anonymous' | 'anonymousb2b';
        const { companyUserOnPrivateSite, privateUserOnCompanySite } = isInB2BCrossContext({
            isB2BRoute: isB2bRoute,
            isAuthenticated: !!shoppingUserId,
            isUserCompany: isCompanyUser,
        });
        if (companyUserOnPrivateSite) {
            userId = 'anonymous';
        } else if (privateUserOnCompanySite) {
            userId = 'anonymousb2b';
        } else if (shoppingUserId) {
            userId = shoppingUserId;
        } else {
            userId = isB2bRoute ? 'anonymousb2b' : 'anonymous';
        }

        const response = await directSectionsApi.getSectionTree(token, productionUnit, userId);

        if (response.length) {
            persistance.ecommerceSections.save(response, {
                productionUnit,
                isB2bRoute,
                isCompanyUser,
                shoppingUserId,
            });
        }
        return response;
    },
};

export default sectionFlow;
